const schoolMarkingAccess = [
    "LE33X", // 聖三一堂小學
    "G31QK", // mAI Mind School
    "SUNJZ", // mAI Mind School 25/26
    "VE5CP", // testing: mLang Hong Kong University

]

export { schoolMarkingAccess };